<template>
    <div class="test" style="min-width: 320px; max-width: 540px;">
        <!-- 页面标题 -->
        <div v-wechat-title="'最强蜗牛 周年100万抽活动'"></div>

        <!-- 头部 -->
        <div class="header" style="min-width: 320px; max-width: 540px;">
          <div class="game">最强蜗牛</div>
          <div class="account">{{ isLoad && user_info.role_name ? (user_info.role_name + '[' + (user_info.account ? (user_info.server_name + ' ' + user_info.server_id + '服') : user_info.os) + ']') : '有梗有趣，还有蜗和鹂' }}</div>
          <div class="official-btn" @click="goLink(downloadUrl, '最强蜗牛_周年100万抽活动_点击前往官网')"></div>
          <div class="login-btn" v-show="!user_info.role_id || !isLoad" @click="isLoad ? showPopup('login') : ''"></div>
          <div :class="['change-btn', user_info.account ? '' : 'channel']" v-show="user_info.role_id && isLoad" @click="user_info.account ? changeOsPopup(true) : osCancel()"></div>
        </div>

        <!-- 活动未开始 -->
        <div :class="'none ' + isWhite"></div>

        <!-- 加载页 -->
        <div :class="['preload', isLoad ? 'over' : '']" style="min-width: 320px; max-width: 540px;">
          <div class="title"></div>
          <div class="machine"></div>
          <div class="bottom"></div>
          <div class="process">
            <div class="line" :style="'width: ' + processWidth + '%;'"></div>
          </div>
        </div>

        <!-- 页面内容 -->
        <div class="content" :style="isLoad ? '' : 'opacity: 0;'">
          <!-- 首页 -->
          <div class="content-01">
            <div class="slogan"></div>
          </div>

          <!-- 百年三卡 -->
          <div class="content-02">
            <div class="title"></div>
            <div class="card">
              <div :class="['item', item ? 'over' : '']" v-for="(item,index) in card_list" :key="index" @click="handleCard(index + 1)">
                {{ index === 1 ? (item ? '' : '6月28日可抽取') : '' }}
                {{ index === 2 ? (item ? '' : '7月5日可抽取') : '' }}
              </div>
            </div>
            <!-- 每日开奖模块 -->
            <div :class="['code', is_win[0] ? 'lucky' : '']">
              <div class="date">{{ onText(4) }}</div>
              <div :class="'super ' + super_icon" @click="showPopup('luck')"></div>
              <div class="before" @click="showPopup('old')"></div>
              <div class="time" v-show="!ordinary_end">下期开奖倒计时：{{ String(countdown.hour).padStart(2, '0') }}:{{ String(countdown.minute).padStart(2, '0') }}:{{ String(countdown.second).padStart(2, '0') }}</div>
              <div class="luck-num">
                <div class="wrap" v-for="(item,index) in 3" :key="index">
                  <div class="item" v-for="(itemB,indexB) in previous_records[0]" :key="indexB">{{ itemB.is_koi_carp === 1 ? '宝石卡锦鲤：' : '' }}{{ itemB.is_koi_carp === 2 ? '周卡锦鲤：' : '' }}{{ itemB.is_koi_carp === 3 ? '季卡锦鲤：' : '' }}{{ itemB.redemption_code }}</div>
                </div>
              </div>
              <div class="luck-none" v-show="!previous_records[0]" text="等待首期开奖">等待首期开奖</div>
              <div class="mine" v-show="code_day">
                我的锦鲤号：{{ code_day ? code_day : '' }}
              </div>
              <div class="text" v-show="!ordinary_end">{{ finish ? '今日抽奖资格已开启' : '尚未获取本日锦鲤抽取资格！'}}</div>
              <div class="btn" @click="showPopup('task')"></div>
            </div>
          </div>

          <!-- 扭蛋机 -->
          <div class="content-03">
            <div class="title"></div>
            <div :class="['machine', ani ? 'ani' : '']">
              <!-- 小球运动 -->
              <div class="glass">
                <div :class="['pellet', 'pellet' + item]" v-for="(item,index) in 9" :key="index"></div>
              </div>
              <!-- 弹幕播报 -->
              <div class="notice">
                <!-- 上一列 -->
                <div class="top">
                  <div class="wrap" v-for="(item,index) in 2" :key="index">
                    <div class="item" v-show="Math.floor(index/2)*2 === index" v-for="(item,index) in broadcast_info" :key="index">恭喜<span class="name">{{ item.role_name }}</span>{{ item.remark }}</div>
                  </div>
                </div>
                <!-- 下一列 -->
                <div class="bottom">
                  <div class="wrap" v-for="(item,index) in 2" :key="index">
                    <div class="item" v-show="Math.floor(index/2)*2 !== index" v-for="(item,index) in broadcast_info" :key="index">恭喜<span class="name">{{ item.role_name }}</span>{{ item.remark }}</div>
                  </div>
                </div>
              </div>
              <div class="rule-btn" @click="showPopup('rule')"></div>
              <div class="lottery-btn" @click="lottery(1)"></div>
              <div class="bubble" @click="showPopup('task')"></div>
              <div class="task-btn" @click="showPopup('task')"></div>
              <div class="lottery-num">剩余硬币：<span>{{times}}</span></div>
              <div class="cloud"></div>
            </div>
            <div class="aside">
              <div class="record" @click="showPopup('record')"></div>
              <div :class="'shell ' + process_icon" @click="showPopup('process')"></div>
            </div>
          </div>

          <!-- 其他活动 -->
          <div class="content-04">
            <div class="item" @click="goLink('https://qcg.ink/IGKXT2', '最强蜗牛_周年100万抽活动_点击前往四周年纪念章页')"></div>
            <div class="item" @click="goLink('https://qcg.ink/LgFu64', '最强蜗牛_周年100万抽活动_点击前往四周年庆典页')"></div>
            <div class="item" @click="goLink('https://l.taptap.cn/9m8CgILz?channel=rep-rep_pes5cq4xey8_h5url1887', '最强蜗牛_周年100万抽活动_点击前往签到补给页')"></div>
          </div>

          <!-- 登录弹窗 -->
          <Login v-if="isShowLogin" v-on:channelCallback="onInit" :gameName="gameName" :loginTypes="loginTypes" :downloadUrl="downloadUrl" channelTips="角色UID可在游戏中—设置—UID查看" noAuthLogin></Login>

          <!-- 绑定弹窗 -->
          <Os v-if='isShowOs' v-on:selectCallback='onInit' v-on:logoutCallback='osCancel' :gameName="gameName"></Os>

          <!-- 弹窗 -->
          <div class="popupWrap" style="min-width: 320px; max-width: 540px;">

            <!-- 百年三卡详情 -->
            <div :class="'popup card ' + card" @click.self="card = false">
              <div class="popup-main">
                <div class="swiper1">
                  <div class="swiper-wrapper">
                    <div :class="['swiper-slide', 'slide-0' + (index + 1)]" v-for="(item,index) in 3" :key="index">
                    </div>
                  </div>
                </div>
                <div class="confirm-btn" @click="card = false"></div>
                <div class="swiper-pagination"></div>
              </div>
            </div>

            <!-- 抽奖记录 -->
            <div :class="'popup record ' + record" @click.self="record = false">
              <div class="popup-main">
                <div class="wrap">
                  <div class="item-wrap" v-for="(item,index) in draw_record" :key="index">
                    <div class="item" v-for="(itemB,indexB) in item.remark" :key="indexB">
                      <div class="name">{{ item.role_name }}</div>
                      <div class="date">{{ onText(1, item.created_at) }}</div>
                      <div :class="['icon', 'icon' + itemB.id]"></div>
                    </div>
                  </div>
                </div>
                <div class="noGet" v-show="!draw_record.length"></div>
                <div class="confirm-btn" @click="record = false"></div>
              </div>
            </div>

            <!-- 超级锦鲤 -->
            <div :class="'popup luck ' + luck" @click.self="luck = false">
              <div :class="['popup-main', super_reward ? (super_win ? 'lucky' : 'unLuck') : '']">
                <div class="time">{{ !super_reward ? ('开奖时间倒计时：' + super_countdown.day + '天 ' + String(super_countdown.hour).padStart(2, '0') + ':' + String(super_countdown.minute).padStart(2, '0') + ':' + String(super_countdown.second).padStart(2, '0')) : '已开奖' }}</div>
                <div class="person">{{ super_lucky_num }}</div>
                <div class="mask" v-show="!super_reward">等待开奖</div>
                <div class="code" v-show="super_reward">
                  <div class="text">超级锦鲤</div>
                  <div class="reward" :text="super_reward">{{ super_reward }}</div>
                </div>
                <div class="mine mine1">{{ '我的锦鲤号：' + personal_super_code }}</div>
                <div class="mine mine2">完成10次活动每日任务获得抽奖资格<span>({{ super_number ? (super_number > 10 ? '10' : super_number) : 0 }}/10)</span></div>
                <div :class="['btn', personal_super_code ? 'over' : '']" @click="personal_super_code ? (luck = false) : (task = true)"></div>
              </div>
            </div>

            <!-- 扭蛋规则 -->
            <div :class="'popup rule ' + rule" @click.self="rule = false">
              <div class="popup-main">
                <div class="wrap">
                  <p>1、活动时间:<span>2024年6月21日-7月11日23:59</span>;</p>
                  <p>2、角色首次进入活动页面时, 自动绑定唯一锦鲤号;</p>
                  <p>3、活动期间, 完成当日硬币任务中所有<span>每日任务</span>, 即可获取当日锦鲤抽取资格;</p>
                  <p>4、活动期间, 每日0点, 在有当日锦鲤抽取资格的角色中, 分别抽出一位已解锁特权对应的锦鲤;</p>
                  <p>5、6月21日解锁宝石卡百年特权, 6月28日解锁穿越者会员百年特权, 7月5日解锁穿越者尊享会员百年特权;</p>
                  <p>6、<span>7月11日晚21:00</span>, 将额外抽取一位超级锦鲤,获取全部三项百年特权, <span>累积完成10次以上所有每日任务的玩家</span>, 均可参与抽取;</p>
                  <p>7、活动期间, 完成任意硬币任务, 即可获取硬币, 开启扭蛋机;</p>
                  <p>8、全服玩家扭蛋<span>累积获取100万张抽奖券, 或活动结束时</span>, 将在全服范围内, 发放限定蜗壳『锦鲤』;</p>
                  <p>9、该活动最终解释权归《最强蜗牛》所有。</p>
                </div>
              </div>
            </div>

            <!-- 硬币任务 -->
            <div :class="'popup task ' + task" @click.self="task = false">
              <div class="popup-main">
                <div :class="['btn', item.status ? 'over' : '']" v-for="(item,index) in task_list" :key="index" @click="Task(item.id, item.status)"></div>
              </div>
            </div>

            <!-- 蜗壳进度 -->
            <div :class="'popup process ' + process" @click.self="process = false">
              <div class="popup-main">
                <div :class="['line-wrap', volute_schedule === 100 ? 'over' : '']" @click="showPopup('shell')">
                  <div class="left">
                    <div class="line" :style="volute_schedule > 50 ? ('transform: rotateZ(' + (3.6 * volute_schedule - 360) + 'deg);') : 'transform: rotateZ(-180deg);'"></div>
                  </div>
                  <div class="right">
                    <div class="line" :style="volute_schedule > 50 ? 'transform: rotateZ(0deg);' : ('transform: rotateZ(' + (3.6 * volute_schedule - 180) + 'deg);')"></div>
                  </div>
                  <div class="icon" :style="'transform: rotateZ(' + (3.6 * volute_schedule) + 'deg);'"></div>
                </div>
                <div class="num">{{ volute_schedule }}%</div>
                <div class="clipboard-btn" @click="copyLink('.clipboard-btn')" data-event="复制活动链接" :data-clipboard-text="share_text"></div>
              </div>
            </div>

            <!-- 蜗壳详情 -->
            <div :class="'popup shell ' + shell" @click.self="shell = false">
              <div class="popup-main"></div>
            </div>

            <!-- 恭喜中奖 -->
            <div :class="'popup reward ' + reward" @click.self="reward = false">
              <div class="popup-main">
                <div :class="['icon', 'icon' + item.reward_id]" v-for="(item,index) in reward_list" :key="index"></div>
                <div class="confirm-btn" @click="reward = false"></div>
              </div>
            </div>

            <!-- 往期号码 -->
            <div :class="'popup old ' + old" @click.self="old = false, preNum = 0">
              <div class="popup-main">
                <div class="wrap">
                  <!-- 本期号码 -->
                  <div :class="['item', preNum === 0 && !ordinary_end ? 'show' : '']">
                    <div class="date">{{ onText(3) }}</div>
                    <div class="inner none-icon" v-if="!finish">暂未获得抽奖资格</div>
                    <div class="inner" v-else>
                      <div class="code">锦鲤号：{{ code_day ? code_day : '' }}</div>
                      <div class="text">已获得资格,等待00:00开奖</div>
                    </div>
                  </div>
                  <!-- 往期号码 -->
                  <div :class="['item', 'oldCode', ordinary_end ? (preNum === index ? 'show' : '') : (preNum === index + 1 ? 'show' : '')]" v-for="(item,index) in previous_records" :key="index">
                    <div class="date">{{ onText(2, item[0].created_at) }}</div>
                    <div :class="['inner', itemB.redemption_code ? '' : 'none-icon']" v-for="(itemB,indexB) in item" :key="indexB">
                      <div class="code">{{ itemB.redemption_code ? '锦鲤号：' + itemB.redemption_code : '暂未获得抽奖资格' }}</div>
                      <div :class="['text', 'text' + itemB.is_koi_carp]" v-show="itemB.redemption_code"></div>
                    </div>
                  </div>
                </div>
                <div class="prev-btn" @click="oldBtn('prev')"></div>
                <div class="next-btn" @click="oldBtn('next')"></div>
              </div>
            </div>

            <!-- 蒙尘 -->
            <div :class="'popup mask ' + mask"></div>

          </div>
        </div>

    </div>
</template>

<script>
import { onLogoutAPI, onInitAPI, onDrawAPI, onTaskAPI, onInfoAPI } from './api'
import { Toast } from 'mint-ui'
import { getTimeStamp, buriedLogger } from '@/utils/utils'
import Clipboard from 'clipboard'
import { mapState, mapMutations, mapActions } from 'vuex'
import Login from '@/components/login'
import Os from '@/components/os'
import { swiper } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'

export default {
  name: 'test',
  components: {
    swiper,
    Login,
    Os
  },
  data () {
    return {
      gameName: 'snail',
      loginTypes: ['sms', 'password', 'channel'],
      downloadUrl: 'http://snail.qingcigame.com/official/',
      isLoad: false, // 预加载是否完成
      processWidth: 3, // 预加载进度条宽度
      preNum: 0, // 往期锦鲤，显示前x期号码
      ani: false, // 扭蛋机动画
      share_text: '', // 复制链接-分享文本
      isWhite: '', // 是否为白名单
      super_icon: false, // 超级锦鲤红点显示
      process_icon: false, // 限定蜗壳红点显示

      card: false, // 百年三卡详情弹窗
      record: false, // 抽奖记录弹窗
      process: false, // 蜗壳进度弹窗
      shell: false, // 蜗壳详情弹窗
      luck: false, // 超级锦鲤弹窗
      rule: false, // 扭蛋规则弹窗
      task: false, // 硬币任务弹窗
      reward: false, // 恭喜中奖弹窗
      old: false, // 往期号码弹窗
      mask: false, // 遮罩

      broadcast_info: [], // 播报内容
      card_list: ['', '', ''], // 三卡是否解锁
      previous_records: [], // 往期开奖记录
      countdown: {}, // 每日开奖倒计时
      super_countdown: {}, // 超级锦鲤开奖倒计时
      super_lucky_num: 0, // 超级锦鲤参与人数
      volute_schedule: 0, // 蜗壳进度
      user_info: {}, // 用户信息
      times: 0, // 扭蛋机抽奖次数
      code_list: [], // 获得号码记录
      task_list: ['', '', '', '', ''], // 硬币任务信息
      finish: false, // 是否完成每日任务
      url_scheme: '', // 企微地址
      tap_link: 'https://l.taptap.cn/9m8CgILz?channel=rep-rep_pes5cq4xey8_h5url1887', // tap地址
      super_number: 0, // 获取超级锦鲤资格-已完成的任务数
      code_day: '', // 用户当前的锦鲤号码
      personal_super_code: '', // 用户的超级锦鲤号
      super_reward: '', // 超级锦鲤本人的号码
      is_win: [], // 用户上一期中奖记录
      super_win: false, // 是否为超级锦鲤
      reward_list: [], // 本次抽奖奖励
      draw_record: [], // 抽奖记录
      ordinary_end: false // 普通锦鲤是否结束
    }
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  created () {
    // 复写
    if (!global.consoleSwitch) console.log = () => {}

    // 自适应
    window.addEventListener('pageshow', this.resize)
    window.addEventListener('resize', this.resize)

    // 清空store上的用户数据
    this.setInitActiveInfo()
    this.setInitUserInfo()

    // 埋点
    const bl = buriedLogger('snail', '最强蜗牛_周年100万抽活动')
    this.logger = bl
    setTimeout(() => {
      this.logger.sum('最强蜗牛_周年100万抽活动_访问页面')
    }, 200)

    this.isSetShare()
  },
  mounted () {
    this.onInfo()
    this.onInit()
    this.preLoad()
  },
  methods: {
    // 自适应
    resize () {
      if (window.innerWidth >= 540) document.documentElement.style.fontSize = '54px'
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.swiper1 ? this.swiper1.init() : this.swiper1Init()
        this.noticeScroll()
      }, 320)
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) this.mouse()

      // 兼容宽屏
      if (window.innerWidth / window.innerHeight > 320 / 470) {
        document.querySelectorAll('.popupWrap .popup .popup-main').forEach(item => {
          item.style.transform = 'scale(0.75)'
        })
      } else if (window.innerWidth / window.innerHeight > 320 / 520) {
        document.querySelectorAll('.popupWrap .popup .popup-main').forEach(item => {
          item.style.transform = 'scale(0.8)'
        })
      } else if (window.innerWidth / window.innerHeight > 320 / 560) {
        document.querySelectorAll('.popupWrap .popup .popup-main').forEach(item => {
          item.style.transform = 'scale(0.9)'
        })
      } else if (window.innerWidth / window.innerHeight > 320 / 620) {
        document.querySelectorAll('.popupWrap .popup .popup-main').forEach(item => {
          item.style.transform = 'scale(0.95)'
        })
      }
    },
    // 获取未登录信息
    onInfo () {
      onInfoAPI({

      }).then(response => {
        if (Number(response.code) === 200) {
          this.card_list = response.data.card_list
          this.previous_records = response.data.previous_records
          this.volute_schedule = response.data.volute_schedule
          this.super_reward = response.data.super_reward
          this.broadcast_info = response.data.broadcast_info
          this.ordinary_end = response.data.ordinary_end

          // 每日开奖倒计时数据处理
          let total = response.data.countdown
          let timer1 = setInterval(() => {
            total--
            this.countdown = this.onDate(total)
            if (!total) {
              clearInterval(timer1)
              this.onInfo()
              this.onInit()
            }
          }, 1000)

          // 超级锦鲤开奖倒计时数据处理
          let total2 = response.data.super_countdown
          let timer2 = setInterval(() => {
            total2--
            this.super_countdown = this.onDate(total2)
            if (!total2) {
              clearInterval(timer2)
              this.onInfo()
              this.onInit()
            }
          }, 1000)

          // 超级锦鲤参与人数数据处理
          this.super_lucky_num = this.onNumber(response.data.super_lucky_num)
          return
        }
        Number(response.code) !== 401 && this.onToast(response.message)
      }).catch(() => {
        // this.onToast('服务器出错啦')
      })
    },
    // 初始化
    onInit () {
      onInitAPI({

      }).then(response => {
        this.isWhite = Number(response.code) !== 403
        if (Number(response.code) === 200) {
          this.onInitDataCallback(response)
          this.user_info = response.data.user_info
          this.times = response.data.activity.times
          this.task_list = response.data.activity.task_list
          this.url_scheme = response.data.activity.url_scheme
          this.code_day = response.data.activity.code_day
          this.is_win = response.data.activity.is_win
          if (!this.is_win) this.is_win = []
          this.personal_super_code = response.data.activity.personal_super_code
          this.draw_record = response.data.activity.draw_record
          this.super_win = response.data.activity.super_win
          this.super_number = response.data.activity.super_number
          this.code_list = response.data.activity.code_list
          if (!localStorage.getItem('snail_super_click' + this.user_info.role_id) && this.super_win) this.super_icon = true
          if (!localStorage.getItem('snail_process_click' + this.user_info.role_id) && this.volute_schedule === 100) this.process_icon = true

          this.finish = this.task_list[0].status && this.task_list[1].status && this.task_list[2].status
          return
        }
        Number(response.code) !== 401 && this.onToast(response.message)
      }).catch(() => {
        // this.onToast('服务器出错啦')
      }).finally(() => {
        document.onvisibilitychange = null
      })
    },
    // 百年三卡轮播图初始化
    swiper1Init () {
      setTimeout(() => {
        this.swiper1 = new Swiper('.swiper1', {
          loop: true,
          centeredSlides: true,
          pagination: '.swiper-pagination',
          speed: 200
        })
      }, 200)
    },
    // 打开三卡轮播图
    handleCard (index) {
      this.swiper1.slideTo(index)
      setTimeout(() => {
        this.showPopup('card')
      }, 200)
    },
    // 弹幕播报
    noticeScroll () {
      let width1 = document.querySelector('.notice .top .wrap').clientWidth
      let width2 = document.querySelector('.notice .bottom .wrap').clientWidth
      let left1 = 0
      let left2 = 0
      if (this.timer3) clearInterval(this.timer3)
      this.timer3 = setInterval(() => {
        left1++
        left2++
        if (left1 > width1) left1 = 0
        if (left2 > width2) left2 = 0
        document.querySelector('.notice .top').style.marginLeft = `-${left1}px`
        document.querySelector('.notice .bottom').style.marginLeft = `-${left2}px`
      }, 30)

      let width3 = document.querySelector('.luck-num .wrap').clientWidth
      let left3 = 0
      if (this.timer4) clearInterval(this.timer4)
      this.timer4 = setInterval(() => {
        left3++
        if (left3 > width3) left3 = 0
        document.querySelector('.luck-num .wrap').style.marginLeft = `-${left3}px`
      }, 30)
    },
    // 预加载
    preLoad () {
      if (this.timer1) clearTimeout(this.timer1)
      this.timer1 = setInterval(() => {
        this.processWidth >= 78 ? clearTimeout(this.timer1) : this.processWidth++
      }, 20)
      window.addEventListener('load', () => {
        this.processWidth = 78
        setTimeout(() => {
          this.isLoad = true
        }, 300)
      })
    },
    // 打开弹窗
    showPopup (name) {
      switch (name) {
        case 'login':
          this.changeLoginPopup(true)
          this.logger.sum('最强蜗牛_周年100万抽活动_打开登录弹窗')
          break
        case 'card':
          this.card = true
          this.logger.sum('最强蜗牛_周年100万抽活动_打开百年三卡详情弹窗')
          break
        case 'record':
          if (!this.user_info.role_id) {
            this.onToast('请先登录')
            this.showPopup('login')
            return
          }
          this.record = true
          this.logger.sum('最强蜗牛_周年100万抽活动_打开抽奖记录弹窗')
          break
        case 'process':
          this.process = true
          if (this.process_icon) {
            this.process_icon = false
            localStorage.setItem('snail_process_click' + this.user_info.role_id, true)
          }
          this.logger.sum('最强蜗牛_周年100万抽活动_打开蜗壳进度弹窗')
          break
        case 'shell':
          this.shell = true
          this.logger.sum('最强蜗牛_周年100万抽活动_打开蜗壳详情弹窗')
          break
        case 'luck':
          if (!this.user_info.role_id) {
            this.onToast('请先登录')
            this.showPopup('login')
            return
          }
          this.luck = true
          if (this.super_icon) {
            this.super_icon = false
            localStorage.setItem('snail_super_click'  + this.user_info.role_id, true)
          }
          this.logger.sum('最强蜗牛_周年100万抽活动_打开超级锦鲤弹窗')
          break
        case 'rule':
          this.rule = true
          this.logger.sum('最强蜗牛_周年100万抽活动_打开扭蛋规则弹窗')
          break
        case 'task':
          if (!this.user_info.role_id) {
            this.onToast('请先登录')
            this.showPopup('login')
            return
          }
          this.task = true
          this.logger.sum('最强蜗牛_周年100万抽活动_打开硬币任务弹窗')
          break
        case 'reward':
          this.reward = true
          this.logger.sum('最强蜗牛_周年100万抽活动_打开恭喜中奖弹窗')
          break
        case 'old':
          if (!this.user_info.role_id) {
            this.onToast('请先登录')
            this.showPopup('login')
            return
          }
          this.old = true
          this.logger.sum('最强蜗牛_周年100万抽活动_打开往期号码弹窗')
          break
        case 'mask':
          this.mask = true
          break
      }
    },
    // 完成任务
    Task (task_id, statue) {
      const that = this
      switch (task_id) {
        case 1:
          // 每日登录游戏一次-待补充
          if (!statue) this.onToast('请前往游戏完成任务')
          break
        case 3:
          this.showPopup('process')
          if (!statue) this.onTask(3)
          break
        case 4:
          document.onvisibilitychange = function () {
            if (document.visibilityState === 'visible') {
              that.onInit() // 初始化
              that.loopInt = setInterval(() => {
                that.onInit() // 检测是否返回应用
              }, 1000)
              setTimeout(() => {
                clearInterval(that.loopInt) // 最多轮询15次，清计时器
              }, 15000)
            }
          }
          this.goLink(this.url_scheme, '最强蜗牛_周年100万抽活动_点击跳转企业微信')
          break
        case 5:
          if (!statue) {
            setTimeout(() => {
              that.onTask(5)
            }, 2000)
          } else {
             this.goLink(this.tap_link, '最强蜗牛_周年100万抽活动_点击跳转TapTap')
          }
          break
      }
    },
    // 完成任务API
    onTask (task_id) {
      onTaskAPI({
        task_id
      }).then(response => {
        if (Number(response.code) === 200) {
          if (task_id === 5) this.goLink(this.tap_link, '最强蜗牛_周年100万抽活动_点击跳转TapTap')
          this.onInit()
          return
        }
        this.onToast(response.message)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    /*
    * 功能：抽奖
    * @param type {number} 1为1抽，2为5抽
    */
    lottery (type) {
      if (!this.user_info.role_id) {
        this.onToast('请先登录')
        this.showPopup('login')
        return
      }
      if (!this.times) {
        return this.onToast('硬币不足，完成任务获取更多硬币')
      }
      this.showPopup('mask')
      onDrawAPI({
        type
      }).then(response => {
        if (Number(response.code) === 200) {
          this.reward_list = response.data
          this.ani = true
          setTimeout(() => {
            this.showPopup('reward')
            this.mask = false
            this.ani = false
            this.onInit()
          }, 2000)
          return
        }
        this.onToast(response.message)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    // 复制链接
    copyLink (copyName) {
      this.share_text = '【最强蜗牛】疯狂四周年开启！参与活动瓜分百万抽奖券，更有机会抽取百年三卡：' + 'https://h5.qingcigame.com/snail/million/enter' + new Date().getTime()
      var _this = this
      const clipboard = new Clipboard(copyName)
      clipboard.on('success', (e) => {
        _this.onToast('复制成功')
        e.clearSelection()
        this.logger.sum('最强蜗牛_周年100万抽活动_复制成功')
      })
      clipboard.on('error', (e) => {
        _this.onToast('复制失败')
      })
    },
    // 区组弹窗注销
    osCancel () {
      onLogoutAPI({
        game_id: this.user_info.game_id
      }).then(response => {
        if (Number(response.code) === 200) {
          this.setInitUserInfo()
          this.user_info = {}
          this.times = 0
          this.shar_task = false
          this.code_list = []
          this.task_list = ['', '', '', '', '']
          this.finish = false
          this.url_scheme = ''
          this.super_number = 0
          this.code_day = ''
          this.personal_super_code = ''
          this.is_win = []
          this.super_win = false
          this.reward_list = []
          this.draw_record = []
          this.super_icon = false
          this.process_icon = false
          return
        }
        this.onToast(response.message)
      }).catch(() => {
        this.onToast('服务器出错啦')
      })
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      }
      if (!config) {
        console.error('缺少config参数')
        return false
      }
      if (typeof config === 'string') {
        curConfig.message = config
      }
      Toast(curConfig)
    },
    // 判断该号码是否中奖
    onCompare (code) {
      let id = 0
      let text = '未中奖'
      for (let item of this.is_win) {
        if (item.redemption_code === code) {
          switch (item.is_koi_carp) {
            case 1:
              // text = '宝石卡锦鲤'
              text = ''
              id = 1
              break
            case 2:
              // text = '周卡锦鲤'
              text = ''
              id = 2
              break
            case 3:
              // text = '季卡锦鲤'
              text = ''
              id = 3
              break
          }
        }
      }
      return {text, id}
    },
    // 往期号码弹窗-按钮效果
    oldBtn (name) {
      switch (name) {
        case 'prev':
          // 前一天
          if (this.ordinary_end) {
            if (this.preNum + 1 <= this.previous_records.length - 1) this.preNum++
          } else {
            if (this.preNum + 1 <= this.previous_records.length) this.preNum++
          }
          break
        case 'next':
          // 后一天
          if (this.preNum - 1 >= 0) this.preNum--
          break
      }
    },
    // 时间转文本
    onText (type, time) {
      let text
      let a = time ? time.split(' ')[0].split('-') : ''
      let b = time ? time.split(' ')[1].split(':') : ''
      switch (type) {
        case 1:
          // 获奖明细日期，6月6日 05:03
          text = Number(a[1]) + '月' + Number(a[2]) + '日 ' + b[0] + ':' + b[1]
          break
        case 2:
          // 往期锦鲤-往期日期
          text = Number(a[1]) + '月' + Number(a[2]) + '日获奖情况'
          break
        case 3:
          // 往期锦鲤-本期日期
          if (this.previous_records[0]) {
            time = this.previous_records[0][0].created_at
            a = time ? time.split(' ')[0].split('-') : ''
            b = time ? time.split(' ')[1].split(':') : ''
            text = new Date(Number(a[0]) + '/' + Number(a[1]) + '/' + (Number(a[2]) + 1)).getTime()
                && new Date(Number(a[0]) + '/' + Number(a[1]) + '/' + (Number(a[2]) + 1)).getMonth() + 1 === Number(a[1])
                ? Number(a[1]) + '月' + (Number(a[2]) + 1) + '日获奖情况'
                : (Number(a[1]) + 1) + '月1日获奖情况'
          } else {
            text = '6月21日获奖情况'
          }
          break
        case 4:
          if (this.previous_records[0]) {
            time = this.previous_records[0][0].created_at
            a = time ? time.split(' ')[0].split('-') : ''
            b = time ? time.split(' ')[1].split(':') : ''
            text = a[1] + a[2] + '期开奖结果'
          } else {
            text = '次日0点开奖'
          }
          break
      }
      return text
    },
    // pc端拖动展示
    mouse () {
      const test = document.getElementsByClassName('test')[0]
      let move = false
      let mouseY
      let that = this
      test.addEventListener('mousedown', function (e) {
        move = !(that.card || that.record || that.process || that.shell || that.luck || that.rule || that.task || that.reward || that.old || that.mask)
        mouseY = e.clientY
      })
      test.addEventListener('mousemove', function (e) {
        if (move) test.scrollTop += (mouseY - e.clientY)
        mouseY = e.clientY
      })
      window.addEventListener('mouseup', function () {
        move = false
      })
    },
    // 时间读秒转对象
    onDate (total) {
      let day = Math.floor(total / 86400)
      let hour = Math.floor((total - day * 86400) / 3600)
      let minute = Math.floor((total - day * 86400 - hour * 3600) / 60)
      let second = total - day * 86400 - hour * 3600 - minute * 60
      return {day, hour, minute, second, total}
    },
    // 数值加入千位符
    onNumber (number) {
      let m = String(number).split('').reverse().join('')
      let t = 0
      while (m.substring(t, t + 3).length === 3) {
        m = m.substring(0, t + 3) + ',' + m.substring(t + 3)
        t = t + 4
      }
      m = String(m).split('').reverse().join('')
      if (m.at(0) === ',') m = m.substring(1)
      return m
    },
    // 前往重定向
    goLink (url, loggerName) {
      if (url === '') return this.onToast('敬请期待！')
      this.logger.sum(loggerName)
      setTimeout(() => { window.location.href = url }, 200)
    },
    // 微信分享
    isSetShare () {
      this.setShare({
        link: `https://h5.qingcigame.com/snail/million/enter${getTimeStamp()}`,
        title: '疯狂百万抽，疯狂四周年',
        imgUrl: 'https://download4.qcplay.com/qcgame-api/vQCPuNtASmp0LZaKzBpR5Kypu04eznL22IyZJru6.png',
        desc: '抢百年三卡，享百年畅玩'
      })
    },
    ...mapMutations([
      'setInitUserInfo',
      'changeOsPopup',
      'setInitActiveInfo',
      'changeLoginPopup'
    ]),
    ...mapActions([
      'setShare',
      'onInitDataCallback'
    ])
  }
}
</script>

<style lang="less">
@import './index.less';
</style>



// WEBPACK FOOTER //
// src/pages/snail/million/test/index.vue